// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"6a090f06","453":"7329f23d","455":"4664e8a1","482":"b609240f","544":"589c362e","669":"9fbb4b0d","708":"f94de6c1"}[chunkId] + ".chunk.js";
};